import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import logo from '../assets/images/logo.png';

const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  color: 'inherit',
}));

const LogoImage = styled('img')(({ theme }) => ({
  display: 'block',
  height: 60,
  width: 'auto',
  [theme.breakpoints.down('md')]: {
    height: 60,
  },
}));

const Logo = () => {
  const logoSrc = logo;
  return (
    <LogoContainer>
      <LogoImage src={logoSrc} alt="Cashew County - NA plots & Holiday Homes" />
    </LogoContainer>
  );
};

export default Logo;